import * as React from 'react'
import { Switch } from '@mui/material'
import { Add, Remove } from '@mui/icons-material'

const BetControls = ({ autoCashoutValue, show,  autoCashout, auto, setAutoBet, placeBet, setNewBet, betAmount, amountOpts, betPlaced, isGameRunning, cashOut, displayPayout, cancelBet, isPlacingBet, betKey }) => {
  
  return (
    <div>
        <div className='flex flex-col space-y-2'>
          
          <div className={`relative bg-[#1b1c1d] ${betPlaced && isGameRunning && 'border border-orange-500'} ${isPlacingBet && 'border border-[#e70c0c]'} p-2 flex flex-col justify-center items-center rounded-lg`}>
            
            <div className='flex bg-[#141516] rounded-full'>
              <button disabled={isPlacingBet} onClick={() => setAutoBet(betKey, false)} className={`text-sm w-[90px] text-center rounded-full cursor-pointer z-20 ${!auto ? 'text-white' : 'text-gray-400 hover:text-red-700'}`}>Bet</button>
              <div className={`absolute transition-transform duration-300 ${!auto ? 'translate-x-0' : 'translate-x-full'} bg-[#2c2d30] w-[90px] h-[20px] text-center rounded-full`}/>
              <button disabled={isPlacingBet} onClick={() => setAutoBet(betKey, true)} className={`text-sm w-[90px] text-center rounded-full cursor-pointer z-20 ${auto ? 'text-white' : 'text-gray-400 hover:text-red-700'}`}>Auto</button>
            </div>

            {
              //1st bet controls
            }
            <div className='grid grid-cols-2 gap-4 py-3 w-full'>
              <div className='flex flex-col space-y-1'>
                <div className='flex justify-between items-center bg-black rounded-full p-1 px-1 space-x-2 text-white font-semibold'>
                  <button disabled={isPlacingBet} onClick={() => setNewBet(null, null, 'remove', betKey)} className='cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Remove fontSize='small'/></button>
                  <p className='px-1 '>{betAmount.toFixed(2)}</p>
                  <button disabled={isPlacingBet} onClick={() => setNewBet(null, null, 'add', betKey)} className='text-sm cursor-pointer rounded-full w-[22px] h-[22px] border-2 border-[#5a5e66] text-[#5a5e66] text-center flex justify-center items-center  font-bold'><Add fontSize='small'/></button>
                </div>

                <div className='grid grid-cols-2 gap-2'>
                  {
                    amountOpts.map((option, index)=>(
                      <button disabled={isPlacingBet} key={index} onClick={() => setNewBet(option.id, option.amt,null, betKey)} className='bg-[#141516] font-semibold cursor-pointer text-sm rounded-full text-center text-[#787b85]'>{option.amt.toFixed(2)}</button>
                    ))
                  }
                </div>


              </div>
                  { isPlacingBet
                    ?
                    <div onClick={isGameRunning && betPlaced   ? () => cashOut(displayPayout, betKey) : () => cancelBet(betKey)} className={`cursor-pointer flex flex-col px-4 ${isGameRunning && betPlaced  ? 'bg-orange-500' : 'bg-[#e70c0c]'} text-2xl border  rounded-[20px] font-semibold text-white justify-center items-center`}>
                        {
                          isGameRunning && betPlaced 
                          ?
                          <div className='flex flex-col justify-center items-center'>
                            <p>Cashout</p>
                            <p>${(displayPayout * betAmount).toFixed(2)}</p>
                          </div>
                          :
                          <p>Cancel</p>
                          }
                    </div>
                    :

                    <div onClick={() => placeBet(betKey)} className={`cursor-pointer flex flex-col px-4 bg-[#28a909] text-2xl border  rounded-[20px] font-semibold text-white justify-center items-center`}>
                      <p>BET</p>
                        <p>${betAmount.toFixed(2)}</p>
                    </div>
                  }
            </div>

            {auto && <div className='flex w-full justify-between items-center'>
              <p onClick={()=> show(true)} className='text-white text-[0.8rem] px-2 bg-blue-600 border border-white rounded-full'>AUTO PLAY</p>
              <div className='flex items-center space-x-1'>
                <p className='text-[0.8rem] text-gray-400'>Auto Cash Out</p>
                <Switch
                onChange={() => autoCashout(betKey,2)}
                sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#efefef', // Thumb color when checked
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#2fff00', // Track color when checked
                    },
                    '& .MuiSwitch-track': {
                    backgroundColor: 'gray', // Default track color
                    },'& .MuiSwitch-thumb': {
                        width: 19, // Keep the thumb size same
                        height: 19,
                      },"& .MuiSwitch-track": {
                        border: "1px solid #8d8e8e", // Border for track
                      },
                }}
                />
              </div>
              <div className='flex justify-between items-center bg-black rounded-full p-1 px-1 space-x-2 text-[#5a5e66] font-semibold'>
                  <p className='px-1 '>{autoCashoutValue.toFixed(2)}</p>
                  <p className='text-sm cursor-pointer w-[22px] h-[22px] text-center flex justify-center items-center  font-bold'>x</p>
                </div>    
            </div>}
          </div>

        </div>
    </div>
  )
}

export default BetControls